import uniqBy from 'lodash/uniqBy';
import { createSelector } from 'reselect';
import { RootState } from '@types';

export const selectOrderPageData = (state: RootState) => state.orderPage.order;
export const selectIsOrderPageLoading = (state: RootState) => state.orderPage.isLoading;

export const selectOrderPageTbd = createSelector(selectOrderPageData, data => {
    if (!data?.tbd_reason) return [];

    const { tbd_reason, tbd_reason_message } = data;
    return [{ tbd_reason, tbd_reason_message }];
});

export const selectOrderPageLineItemsTbd = createSelector(selectOrderPageData, data => {
    if (!data?.line_items) return [];

    return data.line_items
        .map(({ id, tbd_reason, tbd_reason_message }) => ({ id, tbd_reason, tbd_reason_message }))
        .filter(({ tbd_reason }) => Boolean(tbd_reason));
});

export const selectWholeOrderPageTbd = createSelector(
    selectOrderPageTbd,
    selectOrderPageLineItemsTbd,
    (orderTbd, lineItemsTbd) => {
        return uniqBy([...orderTbd, ...lineItemsTbd], ({ tbd_reason }) => tbd_reason);
    },
);

export const selectOrderPageExactTriggersTbd = (currentPurchaseId: number) =>
    createSelector(selectOrderPageTbd, selectOrderPageLineItemsTbd, (orderTbd, lineItemsTbd) => {
        const currentTbd = lineItemsTbd.find(({ id }) => id === currentPurchaseId);

        if (!currentTbd) return orderTbd;

        return [...orderTbd, currentTbd];
    });
